import { Link } from 'react-router-dom'

type LogoProps = {
  href?: string
  size?: 'sm' | 'md' | 'lg'
  subtitle?: string
  light?: boolean
  markOnly?: boolean
}

const sizes = {
  sm: { height: 28, mark: 30 },
  md: { height: 34, mark: 38 },
  lg: { height: 48, mark: 48 },
}

export function Logo({
  href = '/',
  size = 'md',
  subtitle,
  light,
  markOnly,
}: LogoProps) {
  const s = sizes[size]
  const content = markOnly ? (
    <span
      className="logo-mark-wrap"
      style={{ width: s.mark, height: s.mark, minWidth: s.mark, minHeight: s.mark }}
    >
      <img
        src="/brand/logo-mark.png"
        alt="KioskToday"
        width={s.mark}
        height={s.mark}
        className="logo-mark-img"
        decoding="async"
      />
    </span>
  ) : (
    <>
      <img
        src="/brand/app-logo.png"
        alt="KioskToday"
        style={{
          height: `${s.height}px`,
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
          display: 'block',
        }}
        decoding="async"
      />
      {subtitle && (
        <span
          className="logo-sub"
          style={{
            fontSize: '0.72rem',
            color: light ? '#cbd5e1' : 'var(--muted)',
            fontWeight: 600,
            background: light ? 'rgba(255,255,255,0.1)' : '#f1f5f9',
            padding: '0.15rem 0.45rem',
            borderRadius: '4px',
            letterSpacing: '0.02em',
            whiteSpace: 'nowrap',
          }}
        >
          {subtitle}
        </span>
      )}
    </>
  )

  if (href) {
    return (
      <Link to={href} className="logo" aria-label="KioskToday home">
        {content}
      </Link>
    )
  }

  return <div className="logo">{content}</div>
}

